import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import { Link } from 'react-router-dom'

// biome-ignore lint/correctness/noUnusedVariables: TODO
const styles = theme => ({
  root: {
    height: '36px',
    '&:hover': { cursor: 'pointer' },
  },
  primary: {
    border: 'none',
  },
})

const ButtonForLink = ({ children, classes, className, href, linkType, onClick, target, to, type, ...rest }) => {
  const typeOfLink = linkType => {
    if (linkType === 'internal') {
      return Link
    }
    return 'a'
  }

  return (
    <Button
      className={className}
      classes={{
        root: classes.root,
        containedPrimary: classes.primary,
      }}
      color={type}
      component={typeOfLink(linkType)}
      href={href}
      onClick={onClick}
      target={target}
      to={to}
      variant={type === 'primary' ? 'contained' : 'outlined'}
      {...rest}
    >
      {children}
    </Button>
  )
}

ButtonForLink.defaultProps = {
  linkType: 'external',
  type: 'primary',
}

const ButtonForLinkComponent = withStyles(styles)(ButtonForLink)
ButtonForLinkComponent.displayName = 'ButtonForLink'
export default ButtonForLinkComponent
